


















































import { Watch, Component, Vue } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
import Auth from '@aws-amplify/auth';
import API from '@aws-amplify/api';
import Mixin from '../mixin';

@Component
export default class User extends Mixin {
  @State private user: any;
  private name: string = '';
  private email: string = '';
  private pass: string = '';
  private newpass: string = '';
  private confirmation: string = '';

  @Mutation private signIn!: (user: any) => void;
  @Mutation private setCognito!: (cognitouser: any) => void;

  private async mounted() {
    this.name = this.user.Nickname;
    this.email = this.user.Email;
    window.console.log(await Auth.currentUserInfo());
  }

  private async updateAttr(event: any) {
    if (event.target.disabled) {
      return;
    }
    if (this.name === '') {
      this.msg('ユーザー名を入力してください');
      (this.$el.querySelector('#name') as HTMLInputElement).focus();
      return;
    }
    if (this.email === '') {
      this.msg('メールアドレスを入力してください');
      (this.$el.querySelector('#email') as HTMLInputElement).focus();
      return;
    }
    if (document.querySelector('#email:invalid')) {
      this.confirm('メールアドレスの形式が正しくないようです。処理を続行しますか?', () => this.post(event));
    } else {
      this.post(event);
    }
  }

  private async post(event: any) {
    const attr: any = {};
    if (this.name !== this.user.Nickname) {
      attr.nickname = this.name;
    }
    if (this.email !== this.user.Email) {
      attr.email = this.email;
    }
    try {
      event.target.disabled = true;
      const userInfo = await API.post('api', '/user/update', {
        headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
        body: {Nickname: this.name, Email: this.email},
      });
      this.msg('ユーザー情報を更新しました');
      if (attr.email) {
        await Auth.verifyCurrentUserAttribute('email');
      }
      this.signIn(userInfo);
      this.setCognito(await Auth.currentAuthenticatedUser({bypassCache: true}));
    } catch (ex) {
      this.msg(ex);
    } finally {
      event.target.disabled = false;
    }
  }

  private async updatePass(event: any) {
    if (event.target.disabled) {
      return;
    }
    if (this.pass === '') {
      this.msg('現在のパスワードを入力してください');
      (this.$el.querySelector('#oldpass') as HTMLInputElement).focus();
      return;
    }
    if (this.newpass === '') {
      this.msg('パスワードは空にできません');
      (this.$el.querySelector('#newpassword') as HTMLInputElement).focus();
      return;
    }
    if (this.confirmation === '') {
      this.msg('確認用にパスワードをもう一度入力してください');
      (this.$el.querySelector('#confirming') as HTMLInputElement).focus();
      return;
    }
    if (this.newpass !== this.confirmation) {
      this.msg('新パスワードと確認入力が異なります');
      return;
    }
    try {
      event.target.disabled = true;
      const user = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(user, this.pass, this.newpass);
      this.msg('パスワードを更新しました');
      this.updateUser();
      this.pass = '';
      this.newpass = '';
      this.confirmation = '';
    } catch (ex) {
      this.msg(ex);
    } finally {
      event.target.disabled = false;
    }
  }

  private async updateUser() {
    try {
      const userInfo = await API.post('api', '/user', {
        headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
      });
      this.signIn(userInfo);
      this.setCognito(await Auth.currentAuthenticatedUser());
    } catch (ex) {
      this.msg(ex);
    }
  }

}
